<template>
  <div ref="scrollContainer" class="down-page" @scroll="handleScroll($event)">
    <div class="container-wrap">
      <div class="main-wrap">
        <img class="bg" :src="mainBgImg | ossImage(750)" />

        <div class="main-btn dowload-btn" @click="onClickDownload">
          下载{{ APP_CONFIG.app_name }}APP
        </div>
        <div
          v-if="!browerInfo.isMiniProgram && !browerInfo.isMallApp"
          class="main-btn open-btn"
          @click="openAppSchema"
        >
          已下载，打开APP
        </div>
      </div>

      <div class="content-info">
        <div class="title">{{ APP_CONFIG.app_short_name }}优势</div>

        <img class="card" :src="card1 | ossImage(750)" />

        <img class="card" :src="card2 | ossImage(750)" />

        <img class="card" :src="card3 | ossImage(750)" />

        <div class="mp-code-wrap">
          <img class="code" src="../../images/app/mc_mp.png" />

          <div class="tip">保存图片，微信添加小程序</div>
        </div>
      </div>
    </div>

    <!--下载-->
    <div v-if="showFooter" class="download-wrap" @click="onClickDownload">
      <img class="logo" :src="logoImg" />

      <div class="info">
        <span class="title">{{ APP_CONFIG.app_name }}</span>
        <span class="desc"
          >新鲜低价，上{{ APP_CONFIG.app_short_name }}，就是便宜</span
        >
      </div>
      <div class="btn">立即下载</div>
    </div>
  </div>
</template>

<script>
import { openApp, downLoadApp } from '@/utils/app_download'
import {
  APP_CONFIG,
  mainBgImg,
  logoImg,
  ossUrl
} from '@/defines/environment/config'

export default {
  components: {},
  data() {
    return {
      showFooter: false,
      mainBgImg,
      card1: `${ossUrl}spruce_material/ff0e59315bba71cb84b7510bb38026ff`,
      card2: `${ossUrl}spruce_material/dc2f4cac8a8bc5512f4ec4247f836c87`,
      card3: `${ossUrl}spruce_material/2d86c59bc1c2d0060c95a60966c0656b`,
      browerInfo: window.matrix,
      APP_CONFIG,
      logoImg
    }
  },
  created() {
    this.openAppSchema(false)
  },
  methods: {
    openAppSchema(showWxBrowerPopup = true) {
      this.$track(this.$trackMap.appOpen.DOWNLOAD_OPEN_CLICK)
      openApp({
        isOnlyOpen: true,
        showWxBrowerPopup,
        openToast: () => {
          this.$toast({
            message:
              '您当前浏览器版本可能无法自动打开APP，若未正常打开，请尝试手动打开APP。',
            duration: '4000'
          })
        }
      })
    },

    onClickDownload() {
      this.$track(this.$trackMap.appDownload.DOWNLOAD_DOWNLOAD_CLICK)
      downLoadApp()
    },

    handleScroll(event) {
      const scrollTop = event.currentTarget.scrollTop
      if (scrollTop > 100) {
        this.showFooter = true
      } else {
        this.showFooter = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.down-page {
  height: 100vh;
  overflow: auto;

  .container-wrap {
    display: flex;

    flex-direction: column;

    font-size: 0;

    .main-wrap {
      position: relative;

      .bg {
        width: 100%;

        background-repeat: no-repeat;
        background-size: 100% 100%;
      }

      .main-btn {
        position: absolute;
        left: 50%;
        transform: translate(-50%, -50%);

        width: 5.2rem;
        height: 1rem;

        background-image: linear-gradient(147deg, #ff8a51 0%, #ff654d 100%);
        border-radius: 0.5rem;

        font-size: 0.32rem;
        line-height: 1rem;
        font-weight: bold;
        text-align: center;
        color: #ffffff;
        -moz-box-shadow: 0px 4px 20px 0px rgba(21, 137, 50, 0.6);
        box-shadow: 0px 4px 20px 0px rgba(21, 137, 50, 0.6);
        &.dowload-btn {
          top: 63%;
        }

        &.open-btn {
          top: 73%;
        }
      }
    }

    .content-info {
      padding: 0 0.4rem;

      background-color: #ffffff;

      .title {
        padding: 0.36rem 0;

        font-size: 0.5rem;
        font-weight: bold;
      }

      .card {
        width: 100%;
        height: 3.16rem;
        margin-bottom: 0.4rem;

        background-repeat: no-repeat;
        background-size: 100% 100%;
      }

      .mp-code-wrap {
        margin: 0.68rem auto 2.6rem;

        text-align: center;

        .code {
          width: 1.82rem;
          height: 1.82rem;

          background-repeat: no-repeat;
          background-size: 100% 100%;
        }

        .tip {
          margin-top: 0.28rem;

          font-size: 0.28rem;
          color: #666666;
        }
      }
    }
  }

  .download-wrap {
    display: flex;

    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;

    padding: 0.28rem 0.4rem;

    background-color: #ffffff;
    border-top: #f6f6f6 solid 1px;

    align-items: center;

    .logo {
      width: 0.84rem;
      height: 0.84rem;
    }

    .info {
      display: flex;

      width: 0;
      margin-left: 0.24rem;

      flex: 1;
      flex-direction: column;

      .title {
        font-size: 0.32rem;
        font-weight: bold;
      }

      .desc {
        margin-top: 0.12rem;

        font-size: 0.24rem;
        color: #666666;
      }
    }

    .btn {
      width: 1.8rem;
      height: 0.6rem;

      background-color: #15bb5c;
      border-radius: 0.3rem;

      font-size: 0.24rem;
      line-height: 0.6rem;
      text-align: center;
      color: #ffffff;
    }
  }
}
</style>
